import styled from 'styled-components';
//import SplashBackgroundImage from 'assets/BW_SplashBackground.png';
import SplashBackgroundImage from 'assets/Ohio_Figma.jpg';
import OHTrailsLogo from 'assets/Detour OH TRAILS App Logo_FIN_ICO WHT_ALT.png';
import Button from 'calcite-react/Button';
import { CalciteH1 } from 'calcite-react/Elements';
import OHTrailsMiddleImage from 'assets/Web-full-logo3x.png';

const StyledLoginButton = styled(Button)``;

export { StyledLoginButton };

const StyledCalciteH1 = styled(CalciteH1)`
  ${'' /* font-family: ${({ theme }) => theme.type.accentFamily}; */}
  color: black;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.8rem;
  @media (max-width: 575px) {
    font-size: .75rem;
    line-height: .9rem;
  }
`;


const SplashPageLayout = styled.div`

  font-family: Roboto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  min-width: 100vh;
  height: 100%; 
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: linear-gradient(0deg, #4d4d4d, #4d4d4d),
  linear-gradient(0deg, #d8d8d8, #d8d8d8),
  linear-gradient(0deg, #ffffff, #ffffff),
  url(${() => SplashBackgroundImage});
  background-blend-mode: hard-light, multiply, color, normal;
`;

const AppStorePageLayout = styled.div`

  font-family: Roboto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  min-width: 100vh;
  height: 100%; 
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #718B64;



`;

const StyledTermsContainer = styled.div`
  display: flex;
  text-align: left;
  background-color: white;
  padding: 40px;
  width: 40ch;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  height: 50ch;
  overflow: auto;
`;

const ImageAndTermsFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin-top: auto;
  margin-bottom: 2px;
`;

const TopLeftImage = styled.div`
  position: absolute;
  width: 96px;
  height: 96px;
  left: 24px;
  top: 24px;
  display: block;
  background: url(${() => OHTrailsLogo}) no-repeat;
`;

const TopMiddleImage = styled.div`
  width: 335px;
  height: 60px;
  display: block;
  background: url(${() => OHTrailsMiddleImage}) no-repeat;
`;

const BottomBanner = styled.div`
  bottom: 0px;
  left: 0px; 
  margin-top: auto;
  text-align: center;
  background: black;
  width: 100%;
  height: 48px;
  display: flex;
  flexDirection: row;
  justifyContent: center
  alignItems: center;
  textAlign: center;
`;

export { SplashPageLayout, StyledTermsContainer, StyledCalciteH1, TopLeftImage, TopMiddleImage, BottomBanner, AppStorePageLayout, ImageAndTermsFlex };
